<script setup lang="ts">
import { useField } from 'vee-validate';
import { toRef } from 'vue';
import type { VeeCheckboxProps } from '../types';
import Checkbox from './Checkbox.vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeCheckboxProps>();

const veeProps = useVeeFormProps(props);

const emits = defineEmits<{
  change: [value: unknown];
}>();

const {
  errorMessage,
  value: formValue, // use `formValue` because `value` might com from the props as value for checked
  handleChange,
  setTouched,
} = useField(
  toRef(() => props.name),
  undefined,
  {
    type: 'checkbox',
    checkedValue: props.value,
  },
);

function onUpdate(input: unknown | unknown[]) {
  const shouldValidate =
    (!props.noValidationOnCheck && !!input) || (!props.noValidationOnUncheck && !input);
  handleChange(input, shouldValidate);

  setTouched(true);
  emits('change', input);
}
</script>

<template>
  <Checkbox
    v-bind="veeProps"
    :modelValue="formValue"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
  />
</template>
